var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForklift({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_525",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29237",
    "data-name": "Group 29237",
    transform: "translate(138 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -138, -10673)",
    filter: "url(#Ellipse_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_525-2",
    "data-name": "Ellipse 525",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50413",
    "data-name": "Path 50413",
    d: "M62.95,121.674h7.921l6.481,14.1H62.95Z",
    transform: "translate(-179.581 -10771.644)",
    fill: "#ada0ad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50414",
    "data-name": "Path 50414",
    d: "M44.765,216.236H60.457l3.51,11.4h-19.2Z",
    transform: "translate(-162.896 -10858.405)",
    fill: "#ffbf31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50415",
    "data-name": "Path 50415",
    d: "M250.449,109.913a.556.556,0,1,1,1.059-.34l6.241,19.288H267.96a.558.558,0,1,1,0,1.116H257.345v0a.556.556,0,0,1-.53-.386Z",
    transform: "translate(-351.588 -10760.187)",
    fill: "#d1991f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_500",
    "data-name": "Ellipse 500",
    cx: 2.7,
    cy: 2.7,
    r: 2.7,
    transform: "translate(-120 -10628.66) rotate(-73.14)",
    fill: "#847784"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_501",
    "data-name": "Ellipse 501",
    cx: 2.7,
    cy: 2.7,
    r: 2.7,
    transform: "translate(-102.229 -10633.168)",
    fill: "#847784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50416",
    "data-name": "Path 50416",
    d: "M347.472,223.61h7.33a.72.72,0,0,1,.718.718v6.806a.72.72,0,0,1-.718.718h-7.33a.72.72,0,0,1-.718-.718v-6.806A.72.72,0,0,1,347.472,223.61Z",
    transform: "translate(-439.973 -10865.171)",
    fill: "#f0b16e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50417",
    "data-name": "Path 50417",
    d: "M347.472,123.709h7.33a.72.72,0,0,1,.718.718v6.806a.72.72,0,0,1-.718.718h-7.33a.72.72,0,0,1-.718-.718v-6.806A.72.72,0,0,1,347.472,123.709Z",
    transform: "translate(-439.973 -10773.511)",
    fill: "#fcd4a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28980",
    "data-name": "Group 28980",
    transform: "translate(-90.323 -10649.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50418",
    "data-name": "Path 50418",
    d: "M381.849,123.709h2.975v3.552h-2.975Zm0,8.241h2.975V135.5h-2.975Z",
    transform: "translate(-381.849 -123.709)",
    fill: "#e33f65",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.724463b4d5cb7c104f535596c2a08582.svg";
export { ForwardRef as ReactComponent };